import { App, Plugin } from 'vue';
import Col from './Col.vue';

const install = (app: App) => {
  app.component('VCol', Col);
};

Col.install = install;

export { Col };

export default Col as unknown as Plugin;